import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import { exportProvinces, getProvinces } from "store/province/province-action"
import ProvinceListComponent from "components/Province/list"

const ProvinceList = () => {
  const dispatch = useDispatch()
  const { data, error, loading, exportStatus } = useSelector(
    state => state.province
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  // Fetches new province when a page number is clicked
  const onPageClick = link => {
    dispatch(getProvinces(link.url, pageNumber, according, search))
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new Provider Distribution Action Requests based search entered
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getProvinces(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(getProvinces(undefined, pageNumber, according, search))
  }, [pageNumber, according])

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProvinces(search))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Provinces"} />
      <ProvinceListComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default ProvinceList
